import { render, staticRenderFns } from "./ItemTabs.vue?vue&type=template&id=68e8f60c&"
import script from "./ItemTabs.vue?vue&type=script&lang=js&"
export * from "./ItemTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports